import apiClient from './apiClient';
import { ENDPOINTS } from '../config';

/**
 * Service for customer history operations
 */
const customerHistoryService = {
  /**
   * Bulk upload customer history from Excel file
   * @param customerId - Customer ID
   * @param file - Excel file with history data
   * @returns Response with success and error counts
   */
  bulkUploadHistory: async (customerId: string, file: File): Promise<{
    success_count: number;
    error_count: number;
    errors: string[];
  }> => {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await apiClient.postMultipartForm<{
        success_count: number;
        error_count: number;
        errors: string[];
      }>(`${ENDPOINTS.CUSTOMERS}/${customerId}/history/bulk_upload`, formData);

      return response;
    } catch (error) {
      console.error('Error uploading customer history:', error);
      throw error;
    }
  },
};

export default customerHistoryService; 